import { render, staticRenderFns } from "./Subject.vue?vue&type=template&id=61d0dbc2&scoped=true"
import script from "@/views/Subjects/Subject.ts?vue&type=script&lang=ts&external"
export * from "@/views/Subjects/Subject.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Subjects/Subject.scss?vue&type=style&index=0&id=61d0dbc2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d0dbc2",
  null
  
)

export default component.exports